/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_PreviousInputs */

const en_portal_rail_previous = /** @type {(inputs: Portal_Rail_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const pl_portal_rail_previous = /** @type {(inputs: Portal_Rail_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednie`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Portal_Rail_PreviousInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_previous = /** @type {((inputs?: Portal_Rail_PreviousInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_PreviousInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_previous(inputs)
	return en_portal_rail_previous(inputs)
});